//this is bookeeping page
import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBook,
    faChartPie,
    faWallet,
    faIndustry,
    faFileInvoiceDollar,
    faCalculator,
    faEnvelope
} from '@fortawesome/free-solid-svg-icons';
import AOS from 'aos';
import 'aos/dist/aos.css';

// import NSSNavbar from './NSSNavbar';
// import Footer from './Footer';

const services = [
    { icon: faBook, title: 'Meticulous Record-Keeping', description: 'Every spending, revenue, and payment is correctly recorded, giving your financial management a strong foundation.' },
    { icon: faChartPie, title: 'Financial Clarity', description: 'See your company’s financial situation clearly, track progress, spot patterns, and make future plans.', color: 'text-success' },
    { icon: faWallet, title: 'Expense Tracking', description: 'We categorize and organize expenses, making it easier to spot potential areas for cost-cutting strategies.', color: 'text-warning' },
    { icon: faIndustry, title: 'Operational Insights', description: 'Beyond figures, we provide insights and recommendations to improve operations and productivity.', color: 'text-info' },
    { icon: faFileInvoiceDollar, title: 'Invoicing & Receivables', description: 'We ensure timely invoicing and receivables to maintain cash flow and strong client relationships.', color: 'text-danger' },
    { icon: faCalculator, title: 'Effective Tax Preparation', description: 'Accurate financial records simplify and speed up the tax filing process.' },
];

const reasons = [
    { title: 'Expertise', description: 'Our experienced team ensures comprehensive and accurate audits in line with UAE’s regulatory environment.' },
    { title: 'Customized Approach', description: 'We tailor our services to your company’s unique needs and objectives for maximum value.' },
    { title: 'Transparent & Collaborative', description: 'We maintain open communication and work closely with your team throughout the audit process.' },
    { title: 'Time Savings', description: 'Outsource to us and free up your time for strategic planning and core business operations.' },
    { title: 'Data Security', description: 'We safeguard your financial data with advanced security measures to keep it confidential.' },
    { title: 'Professional Support', description: 'Access expert guidance anytime you need it for informed decision-making.' },
];

const Audit = () => {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    const sectionStyles = {
        padding: '80px 0',
        fontFamily: 'Segoe UI, sans-serif'
    };

    const leadStyle = {
        color: '#6c757d',
        fontSize: '1.25rem'
    };

    const cardBaseStyle = {
        borderRadius: '15px',
        transition: 'all 0.3s ease',
        height: '100%',
        cursor: 'pointer'
    };

    const handleMouseEnter = (e) => {
        e.currentTarget.style.backgroundColor = '#adbcb1ff';
        e.currentTarget.style.color = '#fff';
        e.currentTarget.style.transform = 'translateY(-8px)';
        e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)';
    };

    const handleMouseLeave = (e) => {
        e.currentTarget.style.backgroundColor = '#fff';
        e.currentTarget.style.color = '#000';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = 'none';
    };

    return (
        <>
            {/* <NSSNavbar /> */}

            {/* Hero Section */}
            <section
                style={{
                    position: "relative",
                    height: "90vh",
                    backgroundImage: `url('./em4.png')`, // put your image in public folder
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                    textAlign: "center"
                }}
            >
                <div style={{ background: "rgba(0,0,0,0.4)", padding: "20px", borderRadius: "10px" }}>
                   
                    <h1 style={{ fontWeight: "bold", fontSize: "2.5rem" }}>Bookkeeping that build trust and smarter decisions</h1>
                     {/* WhatsApp Button */}
        <a
          href="https://wa.me/yourwhatsappnumber"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-btn"
        >
          <i className="bi bi-whatsapp me-2"></i> Chat on WhatsApp
        </a>
                </div>
            </section>

            <main>
                {/* Intro Section */}
                <section style={{ ...sectionStyles, backgroundColor: '#fff' }}>
                    <Container>
                        <p style={leadStyle} data-aos="fade-up">
                            At <strong>Emkan</strong>,We think that the foundation of any successful company is sound bookkeeping and accounting. In addition to helping you stay in compliance with legal requirements, accurate financial records also provide you with the clarity you need to make informed business decisions. However, handling accounts may be difficult and time-consuming for many business owners, diverting their attention from operations and growth. We can help with that.
                            <details>
  <summary>Read More</summary>
  <p>
    
Complete financial clarity and peace of mind are the goals of our bookkeeping and accounting services. We guarantee that your accounts are correct, current, and fully compliant with UAE requirements by keeping daily records and creating thorough reports. Whether you are a major corporation, a growing SME, or a small startup, we customize our services to fit your particular needs.

We at Emkan do more than just bookkeeping. Our staff of certified accountants thoroughly examines your financial data, looks for trends, and offers insights to help you control expenses, boost productivity, and make future plans. We facilitate your ability to obtain capital, appease investors, and get ready for audits or corporate tax filing by keeping your finances clear and transparent.

We support proactive money management. We assist you in understanding numbers rather than just recording them. We provide you with the information you need to make wise decisions that safeguard your assets and foster expansion through fast reports, cash flow tracking, and spending management.

Every company faces different financial obstacles. Because of this, we provide tailored accounting solutions that support your objectives, be they compliance management, operational efficiency, or establishing a solid financial foundation for growth.

You get more than just a service provider when you work with Emkan; you get a reliable partner who makes sure your books are correct, your finances are transparent, and your company is always ready for the future.
  </p>
</details>

                        </p>
                    </Container>
                </section>

                {/* Services Section */}
                <section style={{ ...sectionStyles, backgroundColor: '#7d94a6ff' }}>
                    <Container>
                        <h2 className="text-white fw-bold text-center mb-5" data-aos="fade-up">Our Bookkeeping Services</h2>
                        <Row className="g-4">
                            {services.map((service, index) => (
                                <Col md={4} key={index} data-aos="zoom-in" data-aos-delay={index * 100}>
                                    <Card
                                        style={cardBaseStyle}
                                        className="p-4 text-center"
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <Card.Body>
                                            <FontAwesomeIcon
                                                icon={service.icon}
                                                className={`fs-1 mb-3 ${service.color || 'text-primary'}`}
                                            />
                                            <h5 className="fw-bold">{service.title}</h5>
                                            <p>{service.description}</p>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>

                {/* Why Choose Us Section */}
                <section style={{ ...sectionStyles, backgroundColor: '#7d94a6ff' }}>
                    <Container>
                        <h2 className="text-white fw-bold text-center mb-5" data-aos="fade-up">Why Choose Emkan?</h2>
                        <Row className="g-4">
                            {reasons.map((reason, index) => (
                                <Col md={4} key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                                    <Card
                                        style={cardBaseStyle}
                                        className="p-4"
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <Card.Body>
                                            <h5 className="fw-bold">{reason.title}</h5>
                                            <p>{reason.description}</p>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>

                {/* CTA Section */}
                {/* <section style={{ ...sectionStyles, backgroundColor: '#f8f9fa', textAlign: 'center' }}>
                    <Container data-aos="fade-up">
                        <h2 className="fw-bold text-primary mb-4">Experience the Benefits of Professional Bookkeeping</h2>
                        <p className="lead mb-4">Let us handle the intricacies of your financial records while you focus on growing your business.</p>
                      
                    </Container>
                </section> */}
            </main>

            {/* <Footer /> */}
        </>
    );
};

export default Audit;
